import { Trans } from '@lingui/react/macro';

import { useNavigate } from '@/components/Link/Link';
import Button from '@/design_system/Button';
import Menu, { MenuItem } from '@/design_system/Menu/Menu';
import IconAdd from '@/icons/Add.svg';
import IconChevron from '@/icons/Chevron.svg';
import { useCreateAgreement } from '@/models/agreements';
import useViewPort from '@/utils/useViewport';

type CreatableAgreementType = 'price_catalog' | 'transit' | 'after_sales';

export const CreateAgreementButton = () => {
  const navigate = useNavigate();
  const { mutateAsync: createAgreement, isPending } = useCreateAgreement();
  const { isMobile, isTablet } = useViewPort();

  const handleCreate = async (type: CreatableAgreementType) => {
    const { id } = await createAgreement({ type });

    navigate(`/settings_beta/network/agreements/${id}?edit=true`);
  };

  return (
    <Menu
      placement="bottom end"
      onAction={(id) => {
        if (id === 'price_catalog' || id === 'transit' || id === 'after_sales') {
          handleCreate(id);
        }
      }}
      trigger={
        isMobile || isTablet ? (
          <Button variant="secondary" size="large" isLoading={isPending} iconOnly>
            <IconAdd />
          </Button>
        ) : (
          <Button variant="secondary" size="medium" isLoading={isPending}>
            <IconAdd />
            <Trans id="settings.organization.entities.agreements.create.button">
              Create agreement
            </Trans>
            <IconChevron down />
          </Button>
        )
      }
    >
      <MenuItem id="price_catalog">
        <Trans id="settings.organization.entities.agreements.create.price">Price agreement</Trans>
      </MenuItem>
      <MenuItem id="transit">
        <Trans id="settings.organization.entities.agreements.create.transit">
          Transit agreement
        </Trans>
      </MenuItem>
      <MenuItem id="after_sales">
        <Trans id="settings.organization.entities.agreements.create.after_sales">
          After-sales agreement
        </Trans>
      </MenuItem>
    </Menu>
  );
};
